interface HeaderProps {
  onSettingsClick: () => void;
  onStatsClick: () => void;
  darkMode: boolean;
}

export default function Header({ onSettingsClick, onStatsClick, darkMode }: HeaderProps) {
  return (
    <header className={`border-b ${darkMode ? 'border-gray-700 bg-gray-900' : 'border-gray-200 bg-white'}`}>
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <button
            onClick={onStatsClick}
            className={`w-10 h-10 flex items-center justify-center rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors cursor-pointer ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}
            aria-label="Statistics"
          >
            <i className="ri-bar-chart-line text-2xl"></i>
          </button>

          <div className="flex items-center gap-3">
            <img 
              src="https://static.readdy.ai/image/f9d0301ca0199288eef8b331aa5b3c77/d2c2b056dccf1f5881d5cc6c653c9f9b.png" 
              alt="Wordle Logo" 
              className="h-10 w-10 object-contain"
            />
            <h1 className={`text-xl sm:text-3xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>
              Unlimited Wordle
            </h1>
          </div>

          <button
            onClick={onSettingsClick}
            className={`w-10 h-10 flex items-center justify-center rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors cursor-pointer ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}
            aria-label="Settings"
          >
            <i className="ri-settings-3-line text-2xl"></i>
          </button>
        </div>
      </div>
    </header>
  );
}
